<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="4"
                lg="4"
                md="4"
                sm="2"
            >
                <h3>Today´s Schedule</h3>
            </v-col>
            <v-col 
                style="text-align: center;"
                cols="12"
                :lg="scheduleClosed == false ? '4' : '3'"
                md="3"
                sm="2"
            >
                <v-tooltip top v-if="showButtonsSubmitForApproval">
                    <template v-slot:activator="{ on }">
                        <v-btn 
                            v-if="showButtonsSubmitForApproval"
                            class="mx-2 v-btn-large"
                            v-on="on"
                            @click="confirmSendApprove"
                        >
                            Submit for Approval
                        </v-btn>
                    </template>
                    <span>Send all changes to approve</span>
                </v-tooltip>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="12"
                :lg="scheduleClosed == false ? '1' : '2'"
                md="2"
                sm="12"
            >
                <v-btn-toggle
                    v-if="showDates"
                    dense
                    v-model="dateOption"
                >
                    <v-btn
                        class="btnToogleToday"
                        @click="getRegisters"
                    >
                        Today - {{ dateTodayFormatted }}
                    </v-btn>

                    <v-btn 
                        class="btnToogleTomorrow"
                        @click="getRegisters"
                    >
                        Tomorrow - {{ dateTomorrowFormatted }}
                    </v-btn>

                </v-btn-toggle>
            </v-col>
            <v-col 
                style="display: flex; flex-direction: row-reverse;"
                cols="12"
                lg="3"
                md="3"
                sm="12"
            >
                <v-tooltip top v-if="scheduleClosed">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-if="scheduleClosed"
                            class="btnToogle"
                            v-on="on"
                            @click="sendEmailToUsers"
                            :disabled="!scheduleClosed"
                        >
                            <v-icon>mdi-email-arrow-right-outline</v-icon>
                        </v-btn>
                    </template>
                    <span>Send email to users</span>
                </v-tooltip>

                <v-tooltip top v-if="scheduleClosed">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-if="scheduleClosed"
                            class="btnToogle"
                            v-on="on"
                            @click="exportFile(URL_TODAY_SCHEDULE_PDF, null);"
                            :disabled="!scheduleClosed"
                        >
                            <v-icon>mdi-file</v-icon>
                        </v-btn>
                    </template>
                    <span>Export to PDF</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="btnToogle"
                            v-on="on"
                            @click="getRegisters"
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>

                <v-btn-toggle
                    v-if="showDates || isApprover"
                    dense
                    v-model="viewMode"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="btnToogle"
                                v-on="on"
                            >
                                <v-icon>mdi-view-column</v-icon>
                            </v-btn>
                        </template>
                        <span>Card View</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="btnToogle"
                                v-on="on"
                            >
                                <v-icon>mdi-view-list-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Table View</span>
                    </v-tooltip>
                </v-btn-toggle>
            </v-col>
        </v-row>

        <v-row
            v-if="showApproveAndDeny"
        >
            <v-col 
                style="text-align: center;"
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn 
                            class="mx-2 v-btn-large"
                            style="background-color: var(--color__red) !important; color: #ffffff !important"
                            v-on="on"
                            @click="confirmApproveOrDeny(1)"
                        >
                            Deny
                        </v-btn>
                    </template>
                    <span>Deny Schedule</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn 
                            class="mx-2 v-btn-large"
                            v-on="on"
                            @click="confirmApproveOrDeny(2)"
                        >
                            Approve
                        </v-btn>
                    </template>
                    <span>Approve Schedule</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row v-if="viewMode == 0">
            <v-col 
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card>
                    <v-card-title class="text-h6 inHouse d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-home</v-icon>
                        <label class="pipelineLabelTitle">In House</label>
                    </v-card-title> 
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listInHouse"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionPreDig != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="preDig_alpha">
                    <v-card-title class="text-h6 preDig d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-account-hard-hat-outline</v-icon>
                        <label class="pipelineLabelTitle">Pre-Dig</label>
                    </v-card-title> 
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listPreDig"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionFrontEnd != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="frontend_alpha">
                    <v-card-title class="text-h6 frontend d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-grid</v-icon>
                        <label class="pipelineLabelTitle">Front End</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listFrontEnd"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionGradingPlumbing != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="grading_plumbing_alpha">
                    <v-card-title class="text-h6 grading_plumbing d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-pipe</v-icon>
                        <label class="pipelineLabelTitle">Grading / Plumbing</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listGradingPlumbing"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionTileDeck != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="tiledeck_alpha">
                    <v-card-title class="text-h6 tiledeck d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-wall</v-icon>
                        <label class="pipelineLabelTitle">Brick & Tile / Deck</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listBrickTileDeck"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionEquipmentElectric != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="equipment_electric_alpha">
                    <v-card-title class="text-h6 equipment_electric d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-home-lightning-bolt</v-icon>
                        <label class="pipelineLabelTitle">Equipment / Electric</label>
                    </v-card-title> 
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listEquipmentElectric"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionPrepPlaster != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="prep_plaster_alpha">
                    <v-card-title class="text-h6 prep_plaster d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-water-opacity</v-icon>
                        <label class="pipelineLabelTitle">Plaster</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listPrepPlaster"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col 
                v-if="userLoggedGetters.profile.constructionBBQ != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="fence_alpha">
                    <v-card-title class="text-h6 fence d-flex">
                        <v-icon left class="pipelineIconTitle" style="margin-top: -5px;">mdi mdi-fence</v-icon>
                        <label class="pipelineLabelTitle">Fence</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listBBQ"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionFence != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="bbq_alpha">
                    <v-card-title class="text-h6 bbq d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-grill-outline</v-icon>
                        <label class="pipelineLabelTitle">BBQ</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listFence"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                v-if="userLoggedGetters.profile.constructionPergola != 0"
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="pergola_alpha">
                    <v-card-title class="text-h6 pergola d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-home-roof</v-icon>
                        <label class="pipelineLabelTitle">Outdoor</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listPergola"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col> 

            <v-col 
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="inspections">
                    <v-card-title class="text-h6 inspections d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-magnify-expand</v-icon>
                        <label class="pipelineLabelTitle">Inspections</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listInspections"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open inspection">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col> 

            <v-col 
                cols="12"
                lg="6"
                md="12"
                sm="12"
            >
                <v-card class="services">
                    <v-card-title class="text-h6 services d-flex">
                        <v-icon left class="pipelineIconTitle">mdi mdi-account-wrench-outline</v-icon>
                        <label class="pipelineLabelTitle">Service</label>
                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-data-table
                            :headers="headersConstruction"
                            :items="listServices"
                            :items-per-page="20"
                            no-data-text="No Record Found"
                            hide-default-footer
                            :single-expand="true"
                            show-expand
                            @click:row="showDetails"
                        >
                            <template v-slot:item.responsibleName="{ item }">
                                <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length">
                                    <h3 style="margin-top: 10px;">Details</h3>
                                    <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                        <thead style="text-align: left;">
                                            <tr>
                                                <th>Step</th>
                                                <th>Name</th>
                                                <th>Customer</th>
                                                <th>Description Of Work</th>
                                                <th>Supervisor / City</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                            <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                                <td>{{ itemDetail.step }}</td>
                                                <td>{{ itemDetail.name }}</td>
                                                <td>{{ itemDetail.customerName }}</td>
                                                <td>{{ itemDetail.description }}</td>
                                                <td>{{ itemDetail.supervisorAndCity }}</td>
                                                <td @click.stop>
                                                    <ActionList 
                                                        :id="itemDetail.id" 
                                                        :showButtons="{
                                                            upDown: dateOption == 1,
                                                            close: itemDetail.status === 2
                                                        }"
                                                        @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                        @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                        @confirmClose="confirmCloseItem(itemDetail)"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col> 
        </v-row>
        <v-row v-else>
            <v-col 
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <v-data-table
                    :headers="headersAllTasks"
                    :items="listAllTasks"
                    :items-per-page="20"
                    no-data-text="No Record Found"
                    hide-default-footer
                    :single-expand="true"
                    show-expand
                    @click:row="showDetails"
                >
                    <template v-slot:item.typeDescription="{ item }">
                        <v-chip
                            :color="item.typeDescription == 'Inspection' ? 'var(--color__inspection)' : 'primary'"
                            label
                            outlined
                            dark
                        >
                            {{ item.typeDescription }}
                        </v-chip>
                    </template>

                    <template v-slot:item.responsibleName="{ item }">
                        <span :style="item.age < 0 ? 'color: red' : ''">{{ item.responsibleName }}</span>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <h3 style="margin-top: 10px;">Details</h3>
                            <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                                <thead style="text-align: left;">
                                    <tr>
                                        <th></th>
                                        <th>Step</th>
                                        <th>Name</th>
                                        <th>Customer</th>
                                        <th>Description Of Work</th>
                                        <th>Supervisor / City</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody :style="item.age < 0 ? 'padding: 10px; color: red' : 'padding: 10px;'">
                                    <tr v-for="(itemDetail, index) in item.listDetails" :key="index" @click="goToWorkOrderOrInspection(itemDetail)" title="Click to open work order">
                                        <td>
                                            <v-chip
                                                :color="getPanelColor(itemDetail)"
                                                label
                                                outlined
                                                dark
                                            >
                                                {{ itemDetail.panelDescription }}
                                            </v-chip>
                                        </td>
                                        <td>{{ itemDetail.step }}</td>
                                        <td>{{ itemDetail.name }}</td>
                                        <td>{{ itemDetail.customerName }}</td>
                                        <td>{{ itemDetail.description }}</td>
                                        <td>{{ itemDetail.supervisorAndCity }}</td>
                                        <td @click.stop>
                                            <ActionList 
                                                :id="itemDetail.id" 
                                                :showButtons="{
                                                    upDown: dateOption == 1,
                                                    close: itemDetail.status === 2
                                                }"
                                                @confirmUp="moveUp(item.listDetails, itemDetail )"
                                                @confirmDown="moveDown(item.listDetails, itemDetail )"
                                                @confirmClose="confirmCloseItem(itemDetail)"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

		<DialogMessage 
			v-on:methodOKToCall="dialogMessage.methodOK"
			:showDialogMessage.sync="dialogMessage.show"
			:headerTitle="dialogMessage.headerText"
			:bodyText="dialogMessage.bodyText"
		/>

        <v-dialog
            v-model="showDialogApproveOrDeny"
            transition="dialog-top-transition"
            persistent
            width="900"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Confirmation
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <label>Description</label>
                            <v-textarea
                                v-model="description"
                                single-line
                                rows="4"
                                row-height="30"
                                outlined
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
                        <v-btn
                            class="mx-2 dialogButtonDismiss v-btn-large"
                            outlined
                            @click="showDialogApproveOrDeny = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            class="mx-2 v-btn-large"
                            outlined
                            @click="confirmSchedule()"
                        >
                            Confirm
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-speed-dial
            v-if="canInsertWorkOrder || canInsertInspection"
            fixed
            v-model="openedFloatButton"
            :top="false"
            :bottom="true"
            :right="true"
            :left="false"
            :direction="'top'"
            :transition="'slide-y-reverse-transition'"
        >
            <template v-slot:activator>
                <v-btn
                    class="mx-2"
                    elevation="24"
                    outlined
                    x-large
                    fab
                    style="background-color: var(--color__red) !important; color: white !important;"
                >
                    <v-icon v-if="openedFloatButton">
                        mdi-close
                    </v-icon>
                    <v-icon v-else>
                        mdi-plus
                    </v-icon>
                </v-btn>
            </template>
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-if="canInsertWorkOrder"
                        fab
                        small
                        v-on="on"
                        style="background-color: white !important;"
                        @click="newWorkOrder" 
                    >
                        <v-icon>mdi-briefcase-outline</v-icon>
                    </v-btn>
                </template>
                <span>New Work Order</span>
            </v-tooltip>
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-if="canInsertInspection"
                        fab
                        small
                        v-on="on"
                        style="background-color: white !important;"
                        @click="newInspection" 
                    >
                        <v-icon>mdi-magnify-expand</v-icon>
                    </v-btn>
                </template>
                <span>New Inspection</span>
            </v-tooltip>
        </v-speed-dial>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";
    import DialogMessage from "@/components/Layout/DialogMessage";
    import {
        CONSTRUCTION_PANEL,
        URL_TODAY_SCHEDULE_PDF
    } from "@/utilities/Enums";
    import * as moment from 'moment';
    import { orderBy } from '@/utilities/Utils';

    export default ({

        components: {
            ActionList,
            ActionDialog,
            DialogMessage
        },

        mixins: [Helpers],

        data: () => ({

            filter: {
                fastSearch: ''
            },
            dateFilter: `${moment().clone().format('YYYY-MM-DD')}T00:00:00`,
            dateTodayFormatted: '',
            dateTomorrowFormatted: '',
            dateTomorrow: '',
            
            listWorkOrder: [],
            listInspectionFiltered: [],

            dateOption: 0,
            viewMode: 0,

            headersConstruction: [
                { text: "Responsible", value: "responsibleName", sortable: false },
                { text: "", value: "action", sortable: false, align: "center" }
            ],

            headersAllTasks: [
                { text: "Type", value: "typeDescription", sortable: false },
                { text: "Responsible", value: "responsibleName", sortable: false },
                { text: "", value: "action", sortable: false, align: "center" }
            ],

            listInHouse: [],
            listPreDig: [],
            listFrontEnd: [],            
            listGradingPlumbing: [],
            listBrickTileDeck: [],
            listEquipmentElectric: [],
            listPrepPlaster: [],
            listFence: [],
            listBBQ: [],
            listPergola: [],
            listServices: [],
            listInspections: [],

            listAllTasks: [],

            todaySchedule: null,
            showDialogApproveOrDeny: false,
            statusSchedule: 0,
            description: null,

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            dialogMessage: {
                show: false,
                headerText: "",
                bodyText: "",
                methodOK: ( () => {} ),
            },

            openedFloatButton: false,
            canInsertWorkOrder: false,
            canInsertInspection: false,

            CONSTRUCTION_PANEL,
            URL_TODAY_SCHEDULE_PDF
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            isApprover() {
                return this.userLoggedGetters.profile.approveTodaySchedule == 1;
            },

            showApproveAndDeny() {
                return this.isApprover == true && 
                       this.todaySchedule != null && 
                       this.todaySchedule.id != 0 && 
                       this.todaySchedule.status == 0;
            },

            scheduleApproved() {
                return this.isApprover == true || 
                       (this.todaySchedule != null && 
                        this.todaySchedule.id != 0 && 
                        this.todaySchedule.status == 2);

            },

            showDates() {
                return this.isApprover == true ||
                       (this.todaySchedule != null && 
                        this.todaySchedule.status < 2);
            },

            showButtonsSubmitForApproval() {
                return this.dateOption == 1 && 
                       this.isApprover == false &&
                       this.todaySchedule != null && 
                       this.todaySchedule.status < 2;
            },

            scheduleClosed() {
                return this.isApprover == true || 
                       (this.todaySchedule != null && 
                        this.todaySchedule.id != 0 && 
                        this.todaySchedule.status == 3);

            },
        },

        methods: {

            getPanelColor (item) {

                let color = "";

                if (item.typeWorkOrder == 1) {
                    return 'var(--color__pipeline_in_progress)';
                }
                else {

                    switch (item.panel) {

                        //Predig
                        case this.CONSTRUCTION_PANEL.PREDIG: color = 'var(--color__construction_dashboard_predig)'; break;

                        //Frontend
                        case this.CONSTRUCTION_PANEL.FRONTEND: color = 'var(--color__construction_dashboard_frontend)'; break;

                        //Grading / Plumbing
                        case this.CONSTRUCTION_PANEL.GRADINGPLUMBING: color = 'var(--color__construction_dashboard_grading_plumbing)'; break;

                        //Brick & Tile / Deck
                        case this.CONSTRUCTION_PANEL.BRICKTILE: color = 'var(--color__construction_dashboard_tiledeck)'; break;

                        //Equipment / Electric
                        case this.CONSTRUCTION_PANEL.EQUIPMENTELETRIC: color = 'var(--color__construction_dashboard_equipment_electric)'; break;

                        //Prep / Plaster
                        case this.CONSTRUCTION_PANEL.PLASTER: color = 'var(--color__construction_dashboard_prep_plaster)'; break;

                        //Fence
                        case this.CONSTRUCTION_PANEL.FENCE: color = 'var(--color__construction_dashboard_fence)'; break;

                        //BBQ
                        case this.CONSTRUCTION_PANEL.BBQ: color = 'var(--color__construction_dashboard_bbq)'; break;

                        //Pergola
                        case this.CONSTRUCTION_PANEL.PERGOLA: color = 'var(--color__construction_dashboard_pergola)'; break;

                        //Services
                        case this.CONSTRUCTION_PANEL.SERVICE: color = 'var(--color__service)'; break;

                        //Inspections
                        case 10: color = 'var(--color__inspection)'; break;

                        default:
                            color = 'var(--color__main)';
                        break;
                    }

                }

                return color
            },

            async getRegisters() {
                this.dateTodayFormatted = moment().clone().format('MM/DD');
                this.dateTomorrowFormatted = moment().add(1, 'days').format('MM/DD');
                this.dateTomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
                this.showLoading();

                await this.checkApprovers();

                await this.filterWorkOrder();
                await this.filterInspection();
                await this.loadInHouse();
                await this.loadPreDig();
                await this.loadFrontEnd();
                await this.loadGradingPlumbing();
                await this.loadBrickTileDeck();
                await this.loadEquipmentElectric();
                await this.loadPrepPlaster();
                await this.loadFence();
                await this.loadBBQ();
                await this.loadPergola();
                await this.loadServices();
                await this.loadInspections();
                await this.loadAllTasks();
                this.hideLoading();
            },

            async checkApprovers() {
                const todayScheduleResult = await this.$store.dispatch(`todayScheduleModule/GetByDate`, this.dateTomorrow);
                    
                if (todayScheduleResult.success) {
                    this.todaySchedule = todayScheduleResult.result;
                }

                if (this.showApproveAndDeny == true) {
                    this.dateOption = 1;
                }
                else {
                    if (this.todaySchedule.status == 1) {
                        this.dateOption = 1;
                        this.dialogMessage = {
                            show: true,
                            headerText: 'Denied',
                            bodyText: `The scheduled was denied <br /><br /> Reason: ${this.todaySchedule.description}`,
                            methodOK: (() => { }),
                        };
                    }
                    else if (this.todaySchedule.status == 2 && this.isApprover == false) {
                        this.dialogMessage = {
                            show: true,
                            headerText: 'Success',
                            bodyText: `The schedule was approved`,
                            methodOK: (async () => { 

                                this.showLoading();
                            
                                const approveOrDenyRequest = {
                                    id: this.todaySchedule.id,
                                    status: 3, //closed
                                    description: "Closed"
                                }
                                await this.$store.dispatch(`todayScheduleModule/ApproveOrDeny`, approveOrDenyRequest);

                                this.getRegisters();

                                this.hideLoading();
                            }),
                        };
                    }
                }
            },

            async filterWorkOrder() {
                const listWorkOrder = await this.$store.dispatch("workOrderModule/ListTodaySchedule");

                if (this.dateOption == 0) { //TODAY
                    this.dateFilter = `${moment().clone().format('YYYY-MM-DD')}T00:00:00`;
                }
                else {
                    this.dateFilter = `${moment().add(1, 'days').format('YYYY-MM-DD')}T00:00:00`;
                }

                const listWorkOrderFiltered = listWorkOrder.filter(wor => wor.status != 7 && ( ( wor.targetDate >= this.dateFilter && wor.targetDate <= this.dateFilter) || (wor.targetDate == null || wor.targetDate == undefined) || (wor.age < 0)) );
                this.listWorkOrder = listWorkOrderFiltered.sort((a, b) => { return orderBy(a, b, 0, 'todayScheduleOrder') });
            },

            async filterInspection() {
                const listInspection = await this.$store.dispatch("inspectionModule/ListTodaySchedule");

                if (this.dateOption == 0) { //TODAY
                    this.dateFilter = `${moment().clone().format('YYYY-MM-DD')}T00:00:00`;
                }
                else {
                    this.dateFilter = `${moment().add(1, 'days').format('YYYY-MM-DD')}T00:00:00`;
                }

                const listInspectionFiltered = listInspection.filter(ins => ins.status != 3 && ( (ins.targetDate >= this.dateFilter && ins.targetDate <= this.dateFilter) || (ins.targetDate == null || ins.targetDate == undefined) || (ins.age < 0) ));

                this.listInspectionFiltered = listInspectionFiltered.sort((a, b) => { return orderBy(a, b, 0, 'todayScheduleOrder') });
            },

            async loadInHouse() {
                this.listInHouse = [];
                const listInHouse = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 1)]; //INTERNAL
                listInHouse.forEach(item => {
                    const itemDetail = this.addDetail(item, 'IH');
                    const existsCrewOrResponsible = this.listInHouse.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listInHouse.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadPreDig() {
                this.listPreDig = [];
                const listPreDig = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.PREDIG)];
                listPreDig.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listPreDig.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listPreDig.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadFrontEnd() {
                this.listFrontEnd = [];
                const listFrontEnd = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.FRONTEND)];

                listFrontEnd.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listFrontEnd.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listFrontEnd.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadGradingPlumbing() {
                this.listGradingPlumbing = [];
                const listGradingPlumbing = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.GRADINGPLUMBING)];
                listGradingPlumbing.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listGradingPlumbing.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listGradingPlumbing.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadBrickTileDeck() {
                this.listBrickTileDeck = [];
                const listBrickTileDeck = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.BRICKTILE)];
                listBrickTileDeck.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listBrickTileDeck.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listBrickTileDeck.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                    
                });

            },

            async loadEquipmentElectric() {
                this.listEquipmentElectric = [];
                const listEquipmentElectric = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.EQUIPMENTELETRIC)];
                listEquipmentElectric.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listEquipmentElectric.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listEquipmentElectric.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadPrepPlaster() {
                this.listPrepPlaster = [];
                const listPrepPlaster = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.PLASTER)];
                listPrepPlaster.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listPrepPlaster.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listPrepPlaster.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadFence() {
                this.listFence = [];
                const listFence = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.FENCE)];
                listFence.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listFence.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listFence.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadBBQ() {
                this.listBBQ = [];
                const listBBQ = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.BBQ)];
                listBBQ.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listBBQ.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listBBQ.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadPergola() {
                this.listPergola = [];
                const listPergola = [...this.listWorkOrder.filter(wor => wor.typeWorkOrder == 2 && wor.panel == this.CONSTRUCTION_PANEL.PERGOLA)];
                listPergola.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listPergola.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listPergola.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadServices() {
                this.listServices = [];
                const listServices = [...this.listWorkOrder.filter(wor => wor.panel == this.CONSTRUCTION_PANEL.SERVICE)];
                listServices.forEach(item => {
                    const itemDetail = this.addDetail(item);
                    const existsCrewOrResponsible = this.listServices.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listServices.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadInspections() {
                this.listInspections = [];
                const listInspections = [...this.listInspectionFiltered];
                listInspections.forEach(item => {
                    const itemDetail = this.addDetailInspection(item);
                    const existsCrewOrResponsible = this.listInspections.find(i => i.responsibleName == item.userNameResponsible);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listInspections.push(this.addItemInspection(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });
            },

            async loadAllTasks() {
                this.listAllTasks = [];
                this.listWorkOrder.forEach(item => {
                    const itemDetail = this.addDetail(item, 'AT');
                    const existsCrewOrResponsible = this.listAllTasks.find(i => i.responsibleName == item.responsibleName);

                    if (existsCrewOrResponsible == null || existsCrewOrResponsible == undefined || existsCrewOrResponsible.length == 0) {
                        this.listAllTasks.push(this.addItem(item, itemDetail));
                    } else {
                        existsCrewOrResponsible.listDetails.push(itemDetail);
                    }
                });

                this.listInspections.forEach(item => {
                    this.listAllTasks.push(item);
                });
            },
            
            addItem(item, itemDetail) {
                return {
                    id: Math.random(),
                    typeDescription: 'Work Order' + ( item.typeWorkOrder == 1 ? ' (In House)' : ''),
                    responsibleName: item.userHelpersNames != '' ? `${item.responsibleName} (${item.userHelpersNames})` : `${item.responsibleName}`,
                    age: item.age,
                    listDetails: [itemDetail]
                }
            },
            
            addItemInspection(item, itemDetail) {
                return {
                    id: Math.random(),
                    typeDescription: 'Inspection',
                    responsibleName: item.userNameResponsible,
                    age: item.age,
                    listDetails: [itemDetail]
                }
            },

            addDetail(item, type = '') {
                return {
                    id: Math.random(),
                    idKey: item.id,
                    type,
                    age: item.age,
                    responsibleName: item.responsibleName,
                    typeWorkOrder: item.typeWorkOrder,
                    panel: item.panel,
                    panelDescription: item.typeWorkOrder == 1 ? 'In House' : item.panelDescription,
                    step: item.stageDescription,
                    name: item.responsibleName,
                    customerName: item.customerName,
                    description: item.scopeOfWork,
                    supervisorAndCity: `${item.supervisorName} / ${item.projectAddress}`,
                    status: item.status,
                }
            },

            addDetailInspection(item) {
                const supervisorName = item.supervisorName == null || item.supervisorName == undefined ? '[NO SUPERVISOR]' : item.supervisorName;
                return {
                    id: Math.random(),
                    idKey: item.id,
                    type: 'IS',
                    age: item.age,
                    responsibleName: item.userNameResponsible,
                    panel: item.panel,
                    panelDescription: item.panelDescription,
                    step: item.stageDescription,
                    name: item.userNameResponsible,
                    customerName: item.customerName,
                    description: item.description,
                    supervisorAndCity: `${supervisorName} / ${item.projectAddress}`,
                    status: item.status,
                }
            },
            
            confirmCloseItem(itemDetail) {
                const isInspection = itemDetail.type === 'IS';
                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: isInspection
                        ? 'You will CLOSE this inspection, confirm your decision?'
                        : 'You will CLOSE this work order, confirm your decision?',
                    methodConfirm: () => this.closeItem(itemDetail),
                    params: null
                };
            },

            async closeItem(itemDetail) {
                this.showLoading();
                let result;
                if (itemDetail.type === 'IS') {
                    result = await this.$store.dispatch('inspectionModule/UpdateStatus', {
                        id: itemDetail.idKey,
                        status: 3,
                        date: this.dateFilter
                    });
                } else {
                    result = await this.$store.dispatch('workOrderModule/UpdateStatus', {
                        id: itemDetail.idKey,
                        status: 7,
                        date: this.dateFilter
                    });
                }
                if (result.success) {
                    this.showToast('success', 'Success!', result.message);
                } else {
                    this.showToast('error', 'Error!', result.message);
                }
                await this.getRegisters();
                this.hideLoading();
            },

            goToWorkOrderOrInspection(item) {
                if (item.type == 'IS') {
                    this.$router.push({ name: 'inspectionForm', params: { id: item.idKey } });
                }
                else {
                    this.$router.push({ name: 'workOrderForm', params: { id: item.idKey } });
                }
            },
            
            showDetails(_, item2) {
                item2.expand(!item2.isExpanded);
            },

            getIndex(lista, id) {
                return lista.findIndex(i => i.id === id);
            },

            moveUp(lista, item) {
                const index = this.getIndex(lista, item.id);

                if (index <= 0) {
                    return lista; // Do nothing
                } 

                const novaLista = [...lista];

                [novaLista[index - 1], novaLista[index]] = [novaLista[index], novaLista[index - 1]];

                this.setList(novaLista, item);

                this.saveChanges();
            },

            moveDown(lista, item) {
                const index = this.getIndex(lista, item.id);

                if (index >= lista.length - 1) {
                    return lista; // Do nothing
                } 

                const novaLista = [...lista];

                [novaLista[index], novaLista[index + 1]] = [novaLista[index + 1], novaLista[index]];

                this.setList(novaLista, item);

                this.saveChanges();
            },

            setList(list, item) {
                // In House
                if (item.type == 'IH') { this.listInHouse.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; }

                // All Tasks
                else if (item.type == 'AT') { this.listAllTasks.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; }

                //Inspection
                else if (item.type == 'IS') { this.listInspections.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; }

                //Work Orders
                else if (item.panel == this.CONSTRUCTION_PANEL.PREDIG) { this.listPreDig.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.FRONTEND) { this.listFrontEnd.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.GRADINGPLUMBING) { this.listGradingPlumbing.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.BRICKTILE) { this.listBrickTileDeck.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.EQUIPMENTELETRIC) { this.listEquipmentElectric.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.PLASTER) { this.listPrepPlaster.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.FENCE) { this.listFence.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.BBQ) { this.listBBQ.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.PERGOLA) { this.listPergola.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
                else if (item.panel == this.CONSTRUCTION_PANEL.SERVICE) { this.listServices.filter(obj => obj.responsibleName == item.responsibleName)[0].listDetails = list; } 
            },

            async confirmSendApprove() {
                this.dialog = {
                    show: true,
                    headerText: 'Submit for Approval',
                    bodyText: 'Are you sure you want to submit this schedule for approval?',
                    methodConfirm: this.sendApprove,
                    params: 0
                };
            },

            async saveChanges() {
                if (this.viewMode == 0) {

                    let order = 0;

                    const uniqueList = [
                        ...new Set([
                            ...this.listInHouse,
                            ...this.listPreDig,
                            ...this.listFrontEnd,
                            ...this.listGradingPlumbing,
                            ...this.listBrickTileDeck,
                            ...this.listEquipmentElectric,
                            ...this.listPrepPlaster,
                            ...this.listFence,
                            ...this.listBBQ,
                            ...this.listPergola,
                            ...this.listServices
                        ])
                    ];

                    for (const item of uniqueList) {

                        for(const itemDetail of item.listDetails) {

                            const updateOrderRequest = {
                                id: itemDetail.idKey,
                                order
                            }
                            
                            await this.$store.dispatch("workOrderModule/UpdateOrder", updateOrderRequest);

                            order++;
                        }
                    }

                    order = 0;

                    for (const item of this.listInspections) {

                        for(const itemDetail of item.listDetails) {

                            const updateOrderRequest = {
                                id: itemDetail.idKey,
                                order
                            }
                            
                            await this.$store.dispatch("inspectionModule/UpdateOrder", updateOrderRequest);

                            order++;
                        }
                    }
                }
                else {
                    let order = 0;

                    for (const item of this.listAllTasks) {

                        for(const itemDetail of item.listDetails) {

                            const updateOrderRequest = {
                                id: itemDetail.idKey,
                                order
                            }

                            let baseModule = '';

                            if (itemDetail.type == 'IS') {
                                baseModule = 'inspectionModule';
                            } else {
                                baseModule = 'workOrderModule';
                            }
                            
                            await this.$store.dispatch(`${baseModule}/UpdateOrder`, updateOrderRequest);

                            order++;
                        }
                    }
                }
            },

            async sendApprove() {
                
                this.showLoading();                

                if (this.isApprover == false) {

                    const todayScheduleRequest = {
                        id: 0,
                        dateSchedule: this.dateTomorrow,
                        status: 0,
                    }
                    await this.$store.dispatch(`todayScheduleModule/CreateUpdate`, todayScheduleRequest);

                    this.dialogMessage = {
                        show: true,
                        headerText: 'Success',
                        bodyText: "The schedule has been submitted for approval.",
                        methodOK: (() => { }),
                    };
                }

                this.getRegisters();
                
                this.hideLoading();
            },

            async confirmApproveOrDeny(idStatus) {
                this.showDialogApproveOrDeny = true;
                this.statusSchedule = idStatus;
            },

            async confirmSchedule() {
                const approveOrDeny = `${this.statusSchedule == 2 ? 'APPROVE' : 'DENY'}`;
                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: `You will ${approveOrDeny} this schedule, confirm your decision?`,
                    methodConfirm: this.approveOrDenySchedule,
                    params: 0
                };
            },

            async approveOrDenySchedule() {
                this.showLoading();

                const approveOrDenyRequest = {
                    id: this.todaySchedule.id,
                    status: this.statusSchedule,
                    description: this.description
                }
                const result = await this.$store.dispatch(`todayScheduleModule/ApproveOrDeny`, approveOrDenyRequest);
                
                if (result.success === true) {
                    this.showToast("success", "Success!", result.message);
                    this.showDialogApproveOrDeny = false;
                    this.getRegisters();
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                }

                this.hideLoading();

            },

            async sendEmailToUsers() {
                this.showLoading();

                const result = await this.$store.dispatch(`todayScheduleModule/SendEmailToUsers`);
                
                if (result.success === true) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                }

                this.hideLoading();
            },

            newWorkOrder() {
                this.$router.push({ name: "workOrderForm", params: {id: 0} });
            },

            newInspection() {
                this.$router.push({ name: "inspectionForm", params: {id: 0} });
            },

            async checkAccess() {
                this.canInsertWorkOrder = false;
                this.canInsertInspection = false;

                const listRoutesFromLocalStorage = localStorage.getItem('listRouters');

                if (listRoutesFromLocalStorage !== null && listRoutesFromLocalStorage !== undefined) {
                    const listRoutesJSON = JSON.parse(listRoutesFromLocalStorage)

                    let accessRoute = listRoutesJSON.filter(rte => rte.name == 'workOrderForm');
                    this.canInsertWorkOrder = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;

                    accessRoute = listRoutesJSON.filter(rte => rte.name == 'inspectionForm');
                    this.canInsertInspection = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;
                }

            },
        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            await this.checkAccess();
            this.hideLoading();
        },
    })
</script>

<style scoped>
    label {
        font-size: 17px !important;
        color: #5e5e5e;
    }

</style>

<style>

    table > tbody > tr {
        cursor: pointer !important;
    }

</style>